import gsap from 'gsap';
import WebGLDistortionSlider from "../WebGLDistortionSlider/WebGLDistortionSlider";

class podcastNetwork {
  constructor(el) {
    this.el = el;
    this.init();
  }

  init() {
    this.initSlider();
    this.infiniteAnimation();
  }

  initSlider() {
      const el = document.getElementById('webgl');
      const container = this.el.querySelector('.podcast-network-hero-slider-wrapper');
      if(!el) return;
      const slider = new WebGLDistortionSlider({
          parent: container,
          canvas: el,
          autoplay: true,
          width: 390,
          height: 390,
          slideDelay: 2500,
          slideSpeed: 1.4,
          initialDelay: 0,
          slidePosDelta: .75,
          secondaryCardScale: 0.87,
      });
  }

  infiniteAnimation() {
    const decorElement = document.querySelector('.podcast-network-banner .decor');
    if (!decorElement) return;

    // Add the animation CSS
    const style = document.createElement('style');
    style.textContent = `
      @keyframes decorAnimation {
        0%, 100% {
          transform: scale(1, 1) translate(0, 0) rotate(0deg);
        }
        50% {
          transform: scale(1.2, 1.8) translate(170px, 170px) rotate(20deg);
        }
      }
    `;
    document.head.appendChild(style);

    // Apply the animation to the element
    decorElement.style.animation = 'decorAnimation 200s linear infinite';
  }

  destroy() {
  }
}

export default podcastNetwork;
